import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "swiper/css";
import 'swiper/css/thumbs';
import { Swiper, SwiperSlide } from "swiper/react";

import { HeaderMain } from './Common/HeaderMain'
import { Footer } from './Common/Footer'
import icon1 from '../img/icon1.svg';
import icon2 from '../img/icon2.svg';
import icon3 from '../img/icon3.svg';
import icon4 from '../img/icon4.svg';
import icon5 from '../img/icon5.svg';
import icon6 from '../img/icon6.svg';
import { Big3Common } from '../js/IncludeManager';
import { GoodsDtl } from './Search/Goods/GoodsDtl';
import { HomeGoodsContainer } from './AdMgr/HomeGoodsContainer';

import { BannerAd, PopupAd } from '../js/ComponentManager';
import { FullPopupAd } from '../js/ComponentManager';
import { MainNoticeMgt } from './Common/MainNoticeMgt';
import { DataContext } from "./Layout";  // Context를 가져옴

export class Home extends Component {
    static displayName = Home.name;
    static contextType = DataContext;
    
    constructor(props) {
        super(props);
        this.state = {
            PackageList: [],
            VisitList:[],
            WorkCompleteList: [],
            WorkDoingList: [],
            TsWorkCompleteList: [],
            TsWorkDoingList:[],
            WorkDate: "",
            item_hide: false,
            MainNotice:[]
        };
        this.refGoodsDtl = React.createRef();             
        this.handleHide_Click = this.handleHide_Click.bind(this);
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
     
    async componentDidMount() {
        //안드로이드 백버튼 제어
        window.addEventListener('scroll', this.handle_onScroll);
        await this.CallOrdMgtListData();
    }
    handleHide_Click() {
        if (this.state.item_hide === true) {
            this.setState({ item_hide: false });
            
        }
        else {
            this.setState({ item_hide: true });
            //로그기록
            Big3Common.RegisterTrackingLog({
                [Big3Common.ContentState.Page_cd]: "MO",
                [Big3Common.ContentState.Basket_Yn]: "N"
            });
        }
    }
    //주문내역 가져오기
    async CallOrdMgtListData() {
        try {

            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/Home/GetTodayWorkList',
                {
                    FromDate: "",
                    ToDate: "",
                    SearchText: "",
                    Ord_Idx: "",
                    CancelListYn: "N",
                    uid_type: this.Uid_Type
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {

                const DataList = JSON.parse(Data.multiDataTable);
                const Work1 = DataList.Work1;
                const Work2 = DataList.Work2;
                const Work3 = DataList.Work3;
                const WorkDate = DataList.returnDate;
                const MainNotice = DataList.MainNotice;

                //택배주문 리스트
                const PackageList = Work3.filter(list => list.ord_use === "TJ");
                //현장방문 리스트
                const VisitList = Work3.filter(list => list.ord_use === "HB");
                //사입완료 리스트
                const WorkCompleteList = Work1.filter(list => list.last_appr_status === "CP");
                //사입주문 리스트
                const WorkDoingList = Work1.filter(list => list.last_appr_status === "OD");
                //택배완료 리스트
                const TsWorkCompleteList = Work2.filter(list => list.last_appr_status === "CP");
                //택배주문 리스트
                const TsWorkDoingList = Work2.filter(list => list.last_appr_status === "OD");

                this.setState({
                    WorkDate: WorkDate,
                    WorkCompleteList: WorkCompleteList,
                    WorkDoingList: WorkDoingList,
                    TsWorkCompleteList: TsWorkCompleteList,
                    TsWorkDoingList: TsWorkDoingList,
                    PackageList: PackageList,
                    VisitList: VisitList,
                    MainNotice: MainNotice
                })
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
         
    }
    async handleGoodsDtl_Click(goods_no, uid,mgr_no) {
        //상세보기 호출
        this.context.Layout_GoodsDtl(
            {
                goods_no: goods_no,
                uid: uid,
                isshow: true,
                headhide: false,
                scrollevent: false
            });
        //로그기록
        Big3Common.RegisterTrackingLog({
            [Big3Common.ContentState.Page_cd]: "DP",
            [Big3Common.ContentState.Uid]: uid,
            [Big3Common.ContentState.Mgr_No]: mgr_no,
            [Big3Common.ContentState.Goods_No]: goods_no,
            [Big3Common.ContentState.Basket_Yn]: "N"
        });
        return false;
    }
    //오늘의 주문현황 마스터
    OrderListrender(MasterData) {
        return (
            <>
                {
                    MasterData.map((list, idx) =>
                        <div className="shop_info_box" key={idx}>
                            <div className="shop_info">
                                <div className="shop_name">{list.whole_name}</div>
                                <div className="shop_Communication">
                                    <div className="shop_text" onClick={() => {
                                        Big3Common.Util.SmsSend(list.user_phone, "");
                                    }}></div>
                                    <div className="shop_call" onClick={() => { window.location.href = `tel:${list.user_phone}` }}></div>
                                </div>
                            </div>
                            <div className="shop_info">
                                <div className="shop_address">상가주소 ({list.bld_name} {list.flr_name}층 {list.whole_no_name}호)</div>
                                <div className="shop_Communication">
                                    {list.peopleyn > 0 ? <div className="shop_buyer"></div> : ""}
                                    {list.boxyn > 0 ? <div className="shop_product"></div> : ""}
                                </div>
                            </div>
                            <div className="shop_memo">{list.last_appr_status === "CP" ? list.buy_memo : list.retail_memo }</div>
                        </div>
                    )
                }
            </>
        )
    }
    //오늘의 주문현황 상세
    ToDayOrderrender() {
       
        const WorkCompleteList = this.state.WorkCompleteList;
        const WorkDoingList = this.state.WorkDoingList;

        const TsWorkCompleteList = this.state.TsWorkCompleteList;
        const TsWorkDoingList = this.state.TsWorkDoingList;

        const VisitList = this.state.VisitList;
        const VisitComplete = VisitList.filter(list => list.ord_status === "GR").length;
        const VisitDoing = VisitList.length - VisitComplete;

        //총 주문건수
        const TotalWorkingCnt = WorkCompleteList.length + WorkDoingList.length + VisitList.length + TsWorkCompleteList.length + TsWorkDoingList.length;
        //완료건수
        const CompleteCount = WorkCompleteList.length + TsWorkCompleteList.length + VisitComplete;
        //미완료 건수
        const DoingCount = TotalWorkingCnt - CompleteCount;
        
        return (
            <div className="today_order_box">
                <div className="main_title_box">
                    <div className="today_title">오늘의 주문 현황</div>
                    <div className="today">{this.state.WorkDate}</div>

                    <div className="fold" onClick={this.handleHide_Click}></div>
                    <div className="unfold item_hide"></div>
                </div>
                <div className="order_number_box">
                    <div className="today_order_number">
                        <div className="tit">총 주문</div>
                        <div className="num color3">{TotalWorkingCnt}</div>
                    </div>
                    <div className="today_order_number">
                        <div className="tit">완료</div>
                        <div className="num color1">{CompleteCount}</div>
                    </div>
                    <div className="today_order_number">
                        <div className="tit">미완료</div>
                        <div className="num color2">{DoingCount }</div>
                    </div>
                </div>
                <div className="order_number_box">
                    <div className="today_order_number2">
                        <div className="m_icon1"></div>
                        <div className="m_icon_t">사입</div>
                        <div className="num"><span className="color1">{WorkCompleteList.length}</span> / <span className="color2">{WorkDoingList.length}</span></div>
                    </div>
                    <div className="today_order_number2">
                        <div className="m_icon2"></div>
                        <div className="m_icon_t">택배</div>
                        <div className="num"><span className="color1">{TsWorkCompleteList.length}</span> / <span className="color2">{TsWorkDoingList.length}</span></div>
                    </div>
                    <div className="today_order_number2">
                        <div className="m_icon3"></div>
                        <div className="m_icon_t">현장</div>
                        <div className="num"><span className="color1">{VisitComplete}</span> / <span className="color2">{VisitDoing }</span></div>
                    </div>
                </div>    
                <div className={this.state.item_hide === true ? "oreder_status_box" : "oreder_status_box item_hide"}>
                    <div className="title_box">
                        <div className="c_icon"></div>
                        <div className="status_n">완료 <span>{this.Uid_Type === 'SS' ? WorkCompleteList.length : TsWorkCompleteList.length}건</span></div>
                    </div>
                    {
                        this.Uid_Type === 'SS' ?
                            <>
                                {this.OrderListrender(this.state.WorkCompleteList)}
                                {this.state.WorkCompleteList.length === 0 ? <div className="no_result2"> {"사입처리 결과가 없습니다."}</div> : ""}
                            </>
                            :
                            <>
                                {this.OrderListrender(this.state.TsWorkCompleteList)}
                                {this.state.TsWorkCompleteList.length === 0 ? <div className="no_result2"> {"택배처리 결과가 없습니다."}</div> : ""}
                            </>
                    }
                </div>
                <div className={this.state.item_hide === true ? "oreder_status_box" : "oreder_status_box item_hide"}>
                    <div className="title_box">
                        <div className="c_icon"></div>
                        <div className="status_n">미완료 <span>{this.Uid_Type === 'SS' ? WorkDoingList.length : TsWorkDoingList.length}건</span></div>
                    </div>
                    {
                        this.Uid_Type === 'SS' ?
                            <>
                                {this.OrderListrender(this.state.WorkDoingList)}
                                {this.state.WorkDoingList.length === 0 ? <div className="no_result2"> {"사입처리 결과가 없습니다."}</div> : ""}
                            </>
                            :
                            <>
                                {this.OrderListrender(this.state.TsWorkDoingList)}
                                {this.state.TsWorkDoingList.length === 0 ? <div className="no_result2"> {"택배처리 결과가 없습니다."}</div> : ""}
                            </>
                    }
                </div>
            </div>
        )
    }
    //상가,여성,남성,잡화 바로가기 아이콘 클릭
    Shortcutsrender() {
        return (
            <Swiper className="category_icon_box" slidesPerView={5}>
                <SwiperSlide className="icon_box">
                    <Link to="/Search/Goods/Index?ManCd=all">
                        <div className="icon icon1">
                            <img src={icon1} alt="전체보기아이콘" />
                        </div>
                        <div className="icon_title">전체보기</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className="icon_box">
                    <Link to="/Search/Goods/Index?ManCd=goods">
                        <div className="icon icon6">
                            <img src={icon6} alt="상가별아이콘" />
                        </div>
                        <div className="icon_title">상가</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className="icon_box">
                    <Link to="/Search/Goods/Index?ManCd=001">
                        <div className="icon icon2">
                            <img src={icon2} alt="여성아이콘" />
                        </div>
                        <div className="icon_title">여성</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className="icon_box">
                    <Link to="/Search/Goods/Index?ManCd=002">
                        <div className="icon icon3">
                            <img src={icon3} alt="남성아이콘" />
                        </div>
                        <div className="icon_title">남성</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className="icon_box">
                    <Link to="/Search/Goods/Index?ManCd=003">
                        <div className="icon icon5">
                            <img src={icon5} alt="잡화아이콘" />
                        </div>
                        <div className="icon_title">잡화</div>
                    </Link>
                </SwiperSlide>
                <SwiperSlide className="icon_box">
                    <Link to="/Search/Goods/Index?ManCd=004">
                        <div className="icon icon4">
                            <img src={icon4} alt="유·아동아이콘" />
                        </div>
                        <div className="icon_title">유·아동</div>
                    </Link>
                </SwiperSlide>
            </Swiper>
        )
    }
    render() {
        const ToDayOrderrender = this.ToDayOrderrender();
        const Shortcutsrender = this.Shortcutsrender();
 
        return (     
            <>
                <MainNoticeMgt
                    MainNotice={this.state.MainNotice}
                />
               
                <div id="parent_goods_list">
                    <HeaderMain />
                    <div className="n_padding p_b_margin container_box_main">
                        {ToDayOrderrender}
                        <BannerAd id="HomeBanner" ads_loc_cd="H1" />
                        {Shortcutsrender}
                        <HomeGoodsContainer
                            GoodsDtlShow={this.handleGoodsDtl_Click }
                        />
 
                        <PopupAd id="PopupAd" />
                        <FullPopupAd id="FullPopupAd" />
                    </div>
                    <Footer fillName="icon1" />
                </div>
              
            </>
        );
  }
}
